/* ==========================================================
   NUAGE – Cart Drawer "Your Cloud"  (Minimog)
   ملف: assets/nuage-cart.js  (ملف جديد)
   1) السحابة بتتحرك من مكانها القديم للجديد على شريط الشحن
   2) زرار + في "Complete the set" بيضيف للسلة بنفس طريقة الثيم
   ========================================================== */
(function () {
  if (window.__nuageCartReady) return;
  window.__nuageCartReady = true;

  /* ---------- 1) حركة السحابة ---------- */
  var lastPct = null;

  function syncJourney() {
    var el = document.querySelector('[data-nq-journey]');
    if (!el || el.getAttribute('data-nq-seen')) return;
    el.setAttribute('data-nq-seen', '1');
    var pct = parseFloat(el.getAttribute('data-pct')) || 0;
    el.style.setProperty('--from', lastPct === null ? 0 : lastPct);
    lastPct = pct;
  }

  function watchDrawer() {
    var drawer = document.getElementById('MinimogCartDrawer');
    if (!drawer) return false;
    syncJourney();
    new MutationObserver(syncJourney).observe(drawer, { childList: true, subtree: true });
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }

  /* ---------- 2) إضافة من الاقتراحات ---------- */
  function showWarning(btn, message) {
    try {
      var target = btn.closest('m-cart-items');
      if (target && window.MinimogTheme && MinimogTheme.Notification) {
        MinimogTheme.Notification.show({
          target: target,
          method: 'prepend',
          type: 'warning',
          message: message
        });
      }
    } catch (e) { /* مش مهم */ }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nq-add]');
    if (!btn || btn.classList.contains('is-loading')) return;
    e.preventDefault();

    var variantId = Number(btn.getAttribute('data-nq-add'));
    if (!variantId) return;

    btn.classList.add('is-loading');

    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(window.MinimogSettings.routes.cart_add_url, config)
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          showWarning(btn, response.description || response.message || 'Could not add this item.');
          return;
        }
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: response });
        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: response } }));
      })
      .catch(function (err) {
        console.error('[Nuage cart] add failed', err);
        showWarning(btn, 'Something went wrong. Please try again.');
      })
      .then(function () {
        btn.classList.remove('is-loading');
      });
  });
})();